<template>
<div class="conteudo-sistema">

	<div v-if="!exibeForm">
		<div class="fl-cabecalho">
			<div class="row animated slideInDown">
				<div class="col-12 form-group">
					<h4 class="animated slideInDown"><fa-icon icon="hdd" /> Equipamentos
						<small class="float-right">
							<a target="_black" style="margin-right:0.5em" :href="_getUrl('api/equipamentoexcel/' + $store.state.sessao.user.token)">
								<fa-icon icon="download"/> Excel
							</a>
						</small>
					</h4>
				</div>
			</div>
			<div class="row animated slideInDown">

				<div class="col-lg-4 form-group col-xs-12">
					<div class="btn-group btn-block btn-group-sm" role="group" aria-label="Basic example">
						<button v-for="(it, idx) in columnsBusca"
								@click="campoBusca = it.key"
								:key="idx"
								type="button"
								class="btn"
								:class="{'btn-primary' : it.key == campoBusca,  'btn-outline-primary' : it.key != campoBusca}">
							{{it.title}}
						</button>
					</div>
				</div>

				<div class="col-lg-4 col-xs-12 form-group">
					<flFind @key-up="(inputText) => busca = inputText"
							textRight="Enter pra buscar"
							placeholder="Buscar"
							@keyup-enter="() => $refs.table.reseta()" />
				</div>

				<div class="col-12 col-lg-2 form-group">
					<button v-if="_getPrivilegio(7)"
							@click="clickModal(null)"
							class="btn btn-sm btn-block btn-outline-dark">
						<fa-icon icon="plus"/> Novo
					</button>
				</div>


			</div>
		</div>

		<flCarregando style="margin-top:20px" v-if="load" />

		<fl-table-server-side 	v-show="!load"
								ref="table"
								:perPage="10"
								@click-detalhe="clickModal"
								@carrega-dados="carregaDados"
								class="animated fadeIn fast"
								columnStartSortable="imei"
								:columns="geraCabecalhos()" />

	</div>

	<div v-if="exibeForm">
		<flDetalhe @fechar="exibeForm = false" ref="equipamento" @item-salvo="atualizaItem" />
	</div>
</div>
</template>

<script>
import _ from 'lodash'
import flDetalhe from "./detalhe/main.vue";
import flCarregando from '../../components/carregando/main.vue'
import axios from '../../routers/axios';
import flTableServerSide from '../../components/table-server-side/main.vue'
import flFind from '../../components/find/main.vue'

export default {
	components: {
		flDetalhe,
		flCarregando,
		flTableServerSide,
		flFind
	},

	data() {
		return {
			load: true,
			exibeForm: false,
			columnsBusca: [
				{ title: "IMEI", key: "imei" },
				{ title: "Registro", key: "registro" },
				{ title: "Cliente", key: "cliente.nome" },
				{ title: "Prefixo", key: "prefixo" },
				{ title: "Modelo", key: "modelo" },
				{ title: "Etiqueta", key: "etiqueta" },
			],
			busca: "",
			campoBusca: "imei",
		};
	},

	methods: {

        clickModal(item){
			this.exibeForm = true
			window.scrollTo(0, 0)
			this.$nextTick(() => {

                if(item != null) this.$refs.equipamento.editar(item._object)
			});
		},

		atualizaItem(item) {

			this.$notify.show('success','Equipamento salvo.')
			this.exibeCadastro = false
		},

		carregaHistorico(item, index) {

			if (item._loadHistorico == false) {
				item._loadHistorico = true;
				axios.get(this._getUrl("api/equipamentohistorico/" + item.id + "/ULTIMO")).then(response => {
					if (response.data == "") {
						item.historico = "Sem Histórico";
					} else {
						item.historico = response.data.descricao;
					}
				});
			}
		},

		carregaDados(columnOrder, order, perPage, start){

			this.load = true
			var url = this._getUrl(`api/equipamento/${columnOrder}/${order}/${perPage}/${start}`);

			if (this.busca.trim() != "") {
				url += `/${this.busca}/${this.campoBusca}`
			}

			axios.get(url).then(response => {
				this.load = false;
				response.data.list = response.data.list.map(item => {
					item._loadHistorico = false
					item.historico = "Carregando..."
					return this.geraColunas(item)
				});

				this.$refs.table.loadTable(response.data.list, response.data.qtd)

			});
		},

		geraColunas(item){

			let itemLista = {}
			let columns = []

			columns.push({ html: item.imei })
			columns.push({
				html: `	${item.registro}
						<br>
						<small class="${item.ativo ? 'text-success': 'text-danger'}">${item.ativo ? 'ATIVADO' : 'DESATIVADO'}</small>`,
			})
			columns.push({ html: `${item.nomeCliente == null ? '' : item.nomeCliente}` })

			columns.push({ html: item.etiqueta })
			columns.push({ html: item.fabricante })
			columns.push({ html: item.modelo })
			columns.push({ html: item.prefixo })

			columns.push({
				class: 'text-center',
				clickable: true,
				event: 'click-detalhe',
				icon: ["far", "arrow-alt-circle-right"],
				style: 'font-size: 1.8em',
			})

			itemLista._object = item
			itemLista.columns = columns
			return itemLista
		},

		geraCabecalhos(){

			let columns = []

			columns.push({
				name: 'Imei',
				key: 'imei',
				sortable: true,
				width: '8%',
			})

			columns.push({
				name: 'Registro',
				key: 'registro',
				keyOrder: 'registro',
				sortable: true,
				width: '5%',
			})

			columns.push({
				name: 'Cliente',
				key: 'cliente.nome',
				sortable: true,
				width: '8%',
			})

			columns.push({
				name: 'Etiqueta',
				key: 'etiqueta',
				sortable: true,
				width: '12%',
			})

			columns.push({
				name: 'Fornecedor',
				key: 'fabricante',
				sortable: true,
				width: '8%',
			})

			columns.push({
				name: 'Modelo',
				key: 'modelo',
				sortable: true,
				width: '5%',
			})

			columns.push({
				name: 'Prefixo',
				key: 'prefixo',
				sortable: true,
				width: '10%',
			})


			columns.push({
				name: 'Detalhes',
				key: 'detalhes',
				sortable: false,
				class: '',
				width: '3%',
			})

			return columns
		},
	}
};
</script>



// WEBPACK FOOTER //
// src/views/equipamento/main.vue